
//{status:30, party:{min:200, avg:400}, property:{min:150, avg: 200}, attachment:20}

export default (width, cols)=>{
    let res={}
    let total = 0
    //debugger
    for (let key in cols){
        let min = cols[key].min || cols[key]
        let avg = cols[key].avg || 0
        if (width < min) break
        res[key]=min
        width -= min
        total += avg
    }
    for (let key in res){
        let avg = cols[key].avg || 0
        if (avg) res[key] += avg*width/total
    }
    return res
}



// WEBPACK FOOTER //
// ./src/utils/calcTable.js